import { compose, withProps } from 'recompose';

import { policies, scopes } from 'bundles/enroll-common/utils/scopedContentRule';
import withScopedContentRule, { useScopedContentRule } from 'bundles/enroll-common/utils/withScopedContentRule';
import type { PropsFromWithScopedContentRule } from 'bundles/enroll-common/utils/withScopedContentRule';

type ContainerProps = {
  s12nId?: string | null;
  courseId?: string;
};

export type EligibilityCheckProps = {
  isCourseraPlusEligibleProduct: boolean;
};

const withCourseraPlusProductEligibilityCheck = <InputProps extends ContainerProps>(isNotRequired?: boolean) =>
  compose<InputProps & EligibilityCheckProps, InputProps>(
    withScopedContentRule<ContainerProps>(scopes.COURSERA_PLUS_SUBSCRIPTION, isNotRequired),
    withProps<EligibilityCheckProps, InputProps & PropsFromWithScopedContentRule>(({ scopedContentRule }) => ({
      isCourseraPlusEligibleProduct: scopedContentRule?.policy === policies.ALLOW,
    }))
  );

export default withCourseraPlusProductEligibilityCheck;

export const useCourseraPlusProductEligibilityCheck = ({
  courseId,
  s12nId,
  skip = false,
}: ContainerProps & { skip?: boolean }): EligibilityCheckProps => {
  const { scopedContentRule } = useScopedContentRule({
    courseId,
    s12nId,
    scope: scopes.COURSERA_PLUS_SUBSCRIPTION,
    skip,
  });

  return {
    isCourseraPlusEligibleProduct: scopedContentRule?.policy === policies.ALLOW,
  };
};
